<div class="wrap">
  <p class="notFound">
    not found
  </p>
</div>

